import state from './state';
import * as mutations from './mutations';
import * as actions from './actions';
import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';

const vuexPersist = new VuexPersist({
  storage: localStorage,
});

export default createStore({
  state,
  getters: {
    getUserToken() {
      return state.userToken;
    },
    getRefreshTokenStartTime() {
      return state.tokenStartTime;
    }
  },
  mutations,
  actions,
  modules: {},
  plugins: [vuexPersist.plugin]
});
